// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/base.css
// module id = Qbok
// module chunks = 11